module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAMAAABhEH5lAAAAS1BMVEUAAAAre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8v///8re8v0+P1vpdz6/P6awOba6PY8hc/Z5/Zdmtc8hs+WvuVcmtclxLAWAAAADHRSTlMA8ttFKMeaAUC/oik065eZAAAAhUlEQVQY023P3Q6DIAxA4QIC6noEf7f3f9IRwhajfpfk0LRS9cGCDU5+uoFm6FpiWOcl52VeMX1tDGnSakqY0kVP0r+Ej+JYa9O6AyeBt57MBLFserJgBbLqTrWrZhBzevqUYXD9uGFlvI4fxXFcl7ivejvo9Xx26TyN76SJLliMDS5K8QWQmAzPOSrS9wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_del1.png
// module id = 31pF
// module chunks = 9